<template>
    <div class="row" :class="{'mb-4': shown}">
        <div class="col-md-2">
            <select class="form-select" v-model="query.centre">
                <option value="iplicit">Iplicit</option>
                <option
                    v-for="centre in centres"
                    :key="centre.id"
                    :value="centre.id"
                >{{ centre.name }}</option>
            </select>
        </div>
        <div class="col-md-2">
            <select class="form-select" v-model="query.docType">
                <option>Invoice</option>
                <option>Credit Note</option>
                <option>Cinolla Payment</option>
                <option>Iplicit Receipt</option>
            </select>
        </div>
        <div class="col-md-2">
            <select class="form-select" v-model="query.dateType">
                <option value="date">Payment/Invoice/Credit Note Date</option>
                <option value="updatedAt">Updated At</option>
            </select>
        </div>
        <div class="col-md-2">
            <input class="form-control" placeholder="From" v-model="query.startDate" v-on:change="wangleStartDate" />
        </div>
        <div class="col-md-2">
            <input class="form-control" placeholder="To" v-model="query.endDate" />
        </div>
        <div class="col-md-2">
            <select class="form-select" v-model="query.limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-2">
            <button class="btn btn-primary mt-4" :disabled="buttonDisabled" v-on:click="updateFilters">
                Search
            </button>
        </div>
    </div>

    <datatable v-if="shown" :url="ajaxUrl" :filters="filters" @receivedHeaders="updateTotalResults">
        <template #headings>
            <template v-if="query.docType == 'Cinolla Payment' || query.docType == 'Iplicit Receipt'">
                <th>Date</th>
            </template>
            <template v-else>
                <th>Type</th>
                <th>Date</th>
                <th>Number</th>
            </template>
            <th>Organisation</th>
            <th>Contact</th>
            <template v-if="query.docType == 'Cinolla Payment' || query.docType == 'Iplicit Receipt'">
                <th>Invoice</th>
                <th>Status</th>
                <th>Payment Method</th>
                <th>Amount</th>
            </template>
            <template v-else>
                <th>Net</th>
                <th>Gross</th>
            </template>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="row in data" :key="row.id">
                <template v-if="query.docType == 'Cinolla Payment' || query.docType == 'Iplicit Receipt'">
                    <td>{{ row.datePaid }}</td>
                </template>
                <template v-else>
                    <td>{{ row.type }}</td>
                    <td>{{ row.date }}</td>
                    <td>{{ row.number }}</td>
                </template>
                <td>{{ row.organisation }}</td>
                <td>{{ row.contact }}</td>
                <template v-if="query.docType == 'Cinolla Payment' || query.docType == 'Iplicit Receipt'">
                    <td>{{ row.invoice }}</td>
                    <td>{{ row.status }}</td>
                    <td>{{ row.paymentMethod }}</td>
                    <td>{{ row.amount }}</td>
                </template>
                <template v-else>
                    <td>{{ row.net }}</td>
                    <td>{{ row.gross }}</td>
                </template>
                <td>
                    <a v-if="row.exists" class="btn btn-secondary" :href="row.show">
                        Show
                    </a>
                    <a v-else-if="row.canImport" class="btn btn-primary" :href="row.import">
                        Import
                    </a>
                    <em v-else>
                        cannot do anything with {{ row.id }}
                    </em>
                </td>
            </tr>
        </template>
    </datatable>
    <p v-if="shown && totalResults > 0">
        {{ totalResults }} Total Results
    </p>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import { reactive, ref, watch } from "vue";

const props = defineProps({
    ajaxUrl: String,
    centres: {
        type: Object,
        required: true,
    },
});

const query = reactive({
    centre: null,
    docType: 'Invoice',
    dateType: 'date',
    startDate: null,
    endDate: null,
    limit: 25,
});

const filters = reactive({});
const shown = ref(false);
const buttonDisabled = ref(true);
const totalResults = ref(0);

const updateTotalResults = (headers) => {
    totalResults.value = headers['x-total-count'];
};

const wangleStartDate = function () {
    const check = query.startDate.match(/(\d{2})-(\d{2})-(\d{4})/);

    if (check !== null) {
        query.startDate = `${check[3]}-${check[2]}-${check[1]}`;
    }

    query.endDate = query.startDate;
};

watch(
    query,
    () => {
        shown.value = false;
        totalResults.value = 0;

        for (const [key, value] of Object.entries(query)) {
            if (! value) {
                buttonDisabled.value = true;
                return;
            }
        }

        buttonDisabled.value = false;
    },
    { deep: true },
);

const updateFilters = () => {
    // as filters is reactive, can't just update the whole thing
    for (const [key, value] of Object.entries(query)) {
        filters[key] = value;
    }
    shown.value = true;
    buttonDisabled.value = true;
};
</script>
